import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Card, CardHeader, CardBody,
  Container, Col, Row,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Form, FormFeedback,
  Input, Button,
  Nav, NavItem, NavLink,
  TabContent, TabPane, 
} from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import classnames from "classnames";

import { FilePond,  registerPlugin } from 'react-filepond';
// Import FilePond styles
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import  { FreeMode, Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper";

SwiperCore.use([FreeMode, Navigation, Thumbs]);
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { createSelector } from "reselect";
import { productionYears, partStatusData, partCategoryData } from "../../common/data/olxCategories";
//import { updatePart as onUpdatePart } from "../../slices/thunks";

import moment from "moment/moment";

import {addPartInitValues, addPartValidationSchema } from "../../models/part";
import AddImagesModal from "../../Components/AddImagesModal";
import ImagePreview from "../../Components/ImagePreview";

//import images
import slack from '../../assets/images/file.png';

import OverviewTab from './OverviewTab';
import DocumentsTab from './DocumentsTab';
import ActivitiesTab from './ActivitiesTab';
import TeamTab from './TeamTab';
import OlxInfoTab from "./OlxInfoTab";

const PartDetailsNew = () => {
    document.title =  "Detalji o dijelu | Sefer IMS";
    //Tab 
    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };
    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg={12}>
                    
                        <Card className="mt-n4 mx-n4">
                            <div className="bg-warning-subtle">
                            <CardBody className="pb-0 px-4">
                                <Row className="mb-3">
                                    <div className="col-md">
                                        <Row className="align-items-center g-3">
                                            <div className="col-md">
                                                
                                                    <h4 className="fw-bold">8898 POLO FABIA IBIZA DISKOVI PLOCICE 1.6 VELIKA KLIJESTA</h4>
                                                    <div className="hstack gap-3 flex-wrap">
                                                        <div>Dodao: <span className="fw-medium">Ajdin Nuhic</span>
                                                        <span className="fw-medium">29 Dec, 2021</span>
                                                    </div>                                                        
                                                    </div>
                                                
                                            </div>
                                            <div className="col-md">                                            
                                            <div className="badge rounded-pill bg-info fs-12">New</div>
                                            <div className="badge rounded-pill bg-danger fs-12">High</div>
                                            </div>
                                        </Row>
                                    </div>
                                </Row>

                                <Nav className="nav-tabs-custom border-bottom-0" role="tablist">
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' }, "fw-bold")}
                                            onClick={() => { toggleTab('1'); }}
                                            href="#">
                                            Overview
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' }, "fw-bold")}
                                            onClick={() => { toggleTab('2'); }}
                                            href="#">
                                            Documents
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' }, "fw-bold")}
                                            onClick={() => { toggleTab('3'); }}
                                            href="#">
                                            Activities
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '4' }, "fw-bold")}
                                            onClick={() => { toggleTab('4'); }}
                                            href="#">
                                            Team
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </CardBody>
                        </div>
                    </Card>
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <TabContent activeTab={activeTab} className="text-muted">
                    <TabPane tabId="1">
                        <OverviewTab />
                    </TabPane>
                    <TabPane tabId="2">
                        <DocumentsTab />
                    </TabPane>
                    <TabPane tabId="3">
                        <ActivitiesTab />
                    </TabPane>
                    <TabPane tabId="4">
                        <TeamTab />
                    </TabPane>
                    </TabContent>
                </Col>
            </Row>
                            
            </Container></div>
    );
};

export default PartDetailsNew;
